import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import { GotoParms, StateService } from '@app/core/services/state.service';
import { UtilityService } from '@app/core/services/utility.service';

@Component({
    selector: 'tt-breadcrumb-item',
    templateUrl: './breadcrumb-item.component.html',
    styleUrls: ['./breadcrumb-item.component.css'],
})
export class BreadcrumbItemComponent {
    @Input()
    public ttGoto = '';

    @Input()
    public ttGotoParms?: GotoParms<unknown>;

    @Output()
    public ttClick = new EventEmitter<MouseEvent>();

    @HostListener('click', ['$event'])
    public onClick(event: MouseEvent) {
        this.ttClick.emit(event);

        if (event.defaultPrevented) return;

        if (!this.ttGoto) return;

        if (this.utility.isModifierKeyPressed(event)) {
            this.state.newTab(this.ttGoto, this.ttGotoParms);
        } else {
            this.state.go(this.ttGoto, this.ttGotoParms);
        }
    }

    constructor(
        private utility: UtilityService,
        private state: StateService,
    ) {}
}
